module.exports = __webpack_public_path__ + "static/img/021_8.1fd4a9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/021_8.jpg
// module id = 3zyS
// module chunks = 1